import { axios } from "../utils/request";

// 1.3.1.1 获取我的订单分页列表
export function getMyStoreOrderListByPage(data) {
  return axios({
    url: '/h5StoreOrder/getMyStoreOrderListByPage',
    method: 'post',
    data
  })
}

// 1.3.1.2 获取订单统计数
export function getStoreOrderNum(data) {
  return axios({
    url: '/h5StoreOrder/getStoreOrderNum',
    method: 'post',
    data
  })
}

// 1.3.1.4 获取订单详情
export function getStoreOrderInfo(data) {
  return axios({
    url: '/h5StoreOrder/getStoreOrderInfo',
    method: 'post',
    data
  })
}


// 1.3.1.3 查询快递物流信息
export function getLogisticsInfo(data) {
  return axios({
    url: '/h5StoreOrder/getLogisticsInfo',
    method: 'post',
    data
  })
}
